// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2mK1n","errors":"Errors_errors__1w_rb"};